import templateApi from '../../../api/template.api'
import _ from 'lodash'

const actions = {
	/**
	 * 直播管理开始
	 */
	// 新增直播
	postAddLiveFn ({state}, params) {
		return templateApi.postAddLive(params).then(res => { return res })
	},

	// 修改直播
	postEditorLiveFn ({state}, params) {
		return templateApi.postEditorLive(params).then(res => { return res })
	},

	// 获取直播列表
	getLiveListFn ({state}, params) {
		return templateApi.getLiveList(params).then(res => { return res })
	},

	/**
	 * 视频管理开始
	 */
	// 获取签名
	getVideoParamFn ({state}, params) {
		return templateApi.getUploadFileParam(params).then(res => { return res })
	},
	// 获取视频封面
	getVideoCoverFn ({state}, params) {
		return templateApi.getUploadFileCover(params).then(res => { return res })
	},
	// 获取视频id
	postVideoIdFn ({state}, params) {
		return templateApi.postUploadVideoId(params).then(res => { return res })
	},
	// 保存编辑视频
	postSaveEditorFn ({state}, params) {
		return templateApi.saveEditorVideo(params).then(res => { return res })
	},
	// 获取视频列表
	getVideoListFn ({state}, params) {
		return templateApi.getVideoList(params).then(res => { return res })
	},

	/**
	 * 保存节点数据
	 * @param state
	 * @param commit
	 * @param {Array} nodes - 节点属性数据列表
	 * @returns {*}
	 */
	saveNodes ({ state, commit, dispatch }, options) {
		commit('setToolbarState', {
			isSave: true,
			isSuccess: false,
			isLoading: false,
			isResult: false
		})
		let pageId = options.pageId || window.sessionStorage.getItem('curDeputyNav') || window.sessionStorage[`${state.projId}-currentId`] || state.indexPageId
		let curEditBlk = state.jquery(`[data-node-id="${options.nodes[0].nodeId}"]`)
		let blkOrder = curEditBlk.parents('[data-blk-name]').attr('data-blk-order')
		let params = {
			pageId: pageId,
			projId: state.projId,
			blkOrder,
			wordIndex: options.wordIndex
		}

		if (options.isbanner) {
			params.isBanner = true
		}
		if (options.moduleId) {
			params.moduleId = options.moduleId
		}
		return templateApi.saveNodes(params, options.nodes).then(
			res => {
				if (res.data.isSuccess) {
					dispatch('getAviliable')
					commit('setToolbarState', {
						isSave: false,
						isSuccess: true,
						isLoading: false,
						isResult: false
					})
					commit('setToolbarStateInit', 200)
				} else {
					commit('setToolbarState', {
						isSave: false,
						isSuccess: false,
						isLoading: false,
						isResult: false,
						isFail: true
					})
					commit('setToolbarStateInit', 200)
				}
				return res
			},
			err => {
				commit('setToolbarState', {
					isSave: false,
					isSuccess: false,
					isLoading: false,
					isResult: false,
					isFail: true
				})
				commit('setToolbarStateInit', 200)
				return err
			}
		)
	},
	/**
	 * 获取撤销及恢复按钮状态
	 * @param state
	 * @returns {*}
	 */
	async getAviliable ({ state, commit }) {
		let res = await templateApi.getAviliable({
			pageId: state.pageId || state.indexPageId,
			projId: state.projId
		})
		let num = res.data.data
		commit('setHistoryBtnShow', num)

		return res
	},
	/**
	 * 获取所有定时发布数据
	 * @param state
	 * @returns {*}
	 */
	async getPublishedPage ({ state, commit }) {
		const params = {
			projectId: state.projId
		}
		const { data } = await templateApi.getPublishedPage(params)
		commit('SET_ALL_TIMING_DATA', data.data)
	},
	/**
	 * 批量增加外部css文件
	 * @param state
	 * @param {Array|String} styles - css文件地址列表
	 */
	parallelLoadStyle ({ state }, styles) {
		if (!styles || !styles.length) return Promise.resolve()
		let doc = state.templateWindow.document
		styles = _.isArray(styles) ? styles : [styles]
		let HEAD = doc.getElementsByTagName('head').item(0) || doc.documentElement,
			styleArray = []
		_.forEach(styles, function (style, index) {
			styleArray[index] = doc.createElement('link')
			styleArray[index].setAttribute('rel', 'stylesheet')
			styleArray[index].setAttribute('href', style)
			HEAD.appendChild(styleArray[index])
		})
	},
	/**
	 * 批量增加外部js文件
	 * @param state
	 * @param {Array|String} scripts - js文件地址列表
	 * @return {Promise}
	 */
	parallelLoadScripts ({ state }, scripts) {
		if (!scripts || !scripts.length) return Promise.resolve()
		return new Promise(resolve => {
			let doc = state.templateWindow.document
			scripts = _.isArray(scripts) ? scripts : [scripts]
			let HEAD = doc.getElementsByTagName('head').item(0) || doc.documentElement,
				scriptArray = [],
				loaded = 0
			_.forEach(scripts, (script, index) => {
				scriptArray[index] = doc.createElement('script')
				scriptArray[index].setAttribute('type', 'text/javascript')
				scriptArray[index].onload = scriptArray[index].onreadystatechange = function (event) {
					if (event.type === 'load' || /^(complete|loaded)$/.test((event.currentTarget || event.srcElement).readyState)) {
						loaded++
						this.onload = this.onreadystatechange = null
						if (loaded === scripts.length) {
							resolve(doc)
						}
					}
				}
				scriptArray[index].setAttribute('src', script)
				HEAD.appendChild(scriptArray[index])
			})
		})
	},
	/*
	 * 获取项目信息*/
	getProjectInfo ({ state, commit }, params) {
		return new Promise((resolve, reject) => {
			templateApi.getProjectInfo({
				projId: state.projId || params.projId
			}).then(res => {
				let { data } = res
				commit('setConfigFtp', {
					ftpId: data.data.ftpId,
					isPlanDomain: data.data.isPlanDomain
				})
				resolve(res)
			}, err => {

			})
		})
	},

	saveHtmlInDatabase ({ state, dispatch, commit }) {
		commit('setToolbarState', {
			isSave: true,
			isSuccess: false,
			isLoading: false,
			isResult: false
		})

		return templateApi
			.saveHtmlInDatabase(
				{},
				{
					pageId: state.pageId || state.indexPageId,
					projId: state.projId
				}
			)
			.then(
				res => {
					commit('setToolbarState', {
						isSave: false,
						isSuccess: true,
						isLoading: false,
						isResult: false
					})
					commit('setToolbarStateInit', 300)

					return res
				},
				err => {
					let status = err.request.status
					commit('setToolbarState', {
						isSave: false,
						isSuccess: false,
						isLoading: false,
						isResult: false,
						isFail: true
					})
					commit('setToolbarStateInit', 300)
				}
			)
	},
	deletePage ({ state }, params) {
		return templateApi.deletePage(params)
	},
	copyPage (context, params) {
		return templateApi.copyPage({}, params)
	},
	/*
	 * 获取已经删除的页面
	 * */
	getDeletePage ({ state }) {
		return templateApi.getDeletePage({
			projId: state.projId,
			status: 1
		})
	},

	recoverPage ({ state }, params) {
		return templateApi.recoverPage({}, params)
	},
	completelyDeletePage ({ state }, params) {
		return templateApi.completelyDeletePage(params)
	},

	/*
	 * getPageSeo*/
	getPageSeo ({ state }, params) {
		return templateApi.getPageSeo(params)
	},
	/*
	 * savePageSeo*/
	savePageSeo ({ state }, options) {
		return templateApi.savePageSeo(
			{
				...options.data
			},
			{
				projId: state.projId,
				...options.params
			}
		)
	},
	getNavInfo ({ state }, params = { projId: state.projId, navType: 1 }) {
		return templateApi.getNavInfo(params)
	},
	getPrevHistory ({ state, commit }) {
		return templateApi.getPrevHistory({
			pageId: state.pageId || state.indexPageId,
			projId: state.projId
		})
	},
	getNextHistory ({ state, commit }) {
		return templateApi.getNextHistory({
			pageId: state.pageId || state.indexPageId,
			projId: state.projId
		})
	},

	addTplPage ({ state }, params) {
		return templateApi.addTplPage(params)
	},
	uploadImgByUrl ({ state }, params) {
		return templateApi.uploadImgByUrl(params)
	},
	addNavLink ({ state }, params) {
		return templateApi.addNavLink({
			projId: state.projId,
			...params
		})
	},
	checkEdit ({ state }, params) {
		return templateApi.checkEdit(params)
	},
	//获取排队信息
	getProjectCheckState ({ state }, params) {
		return templateApi.getProjectCheckState(params)
	},
	/**
	 * 查看项目是发布还是检查
	 * @param params.taskId  发布的taskId
	 * @returns {*}
	 */
	getProjectQueue ({ state }, params) {
		return templateApi.getProjectQueue(params)
	},
	/**
	 * 会员中心-我的课程
	 * @param params.offset    页码
	 * @param params.count        页数
	 * @param params.videoTypeName    //获取全部课程填写全部课程
	 * @param params.status    状态 0代表未学习完，1代表已学习完
	 * @returns {*}
	 */
	getNoLookNum ({ state }, params) {
		return templateApi.getNoLookNum(params)
	},
	/**
	 * 发送检测
	 * @param params.projId
	 * @param params.taskId
	 * @param params.publishType = 2
	 * @returns {*}
	 */
	sendCheck ({ state }, params) {
		return templateApi.sendCheck(params)
	},
	/**
	 * 获取发布进度
	 * @param params
	 * @returns {*}
	 */
	getProgress ({ state }, params) {
		return templateApi.getProgress(params)
	},
	/**
	 * 检查回调结果查询
	 * @param params.projId
	 * @param params.pageNo
	 * @param params.pageSize
	 * @returns {*}
	 */
	getResult ({ state }, params) {
		return templateApi.getResult(params)
	},
	/**
	 * 获取可检测次数
	 * @param params.projId
	 * @returns {*}
	 */
	getCheckCount ({ state }, params) {
		return templateApi.getCheckCount(params)
	},
	/**
	 * 会员中心-检测是否能发布
	 * @param params
	 * @returns {*}
	 */
	getPublished ({ state }, params) {
		return templateApi.getPublished(params)
	},
	getPageByHref ({ state }, params) {
		params.projId = state.projId
		return templateApi.getPageByHref(params)
	},
	// 获取副导航数据
	async getAllCatePageListData ({ state, commit, dispatch }) {
		let { data } = await dispatch('getNavInfo', { projId: state.projId, navType: 2 })
		if (data.isSuccess) {
			commit('setState', { categoryPageData: data.data })
		} else {
			console.log('获取分类页数据失败')
		}
	},
	/**
	 * 通过页面id和页面类型获取构件相关数据
	 * @param params
	 * @returns {*}
	 */
	getStructurePage ({ state }, params) {
		return templateApi.getStructurePage(params)
	},
	/**
	 * 通过项目id和页面类型获取构件相关数据
	 * @param params
	 * @returns {*}
	 */
	getStructureProj ({ state }, params) {
		return templateApi.getStructureProj(params)
	},
	//	保存或更新页面构件关联
	saveOrUpdate ({ state }, params) {
		return templateApi.saveOrUpdate(params)
	},
	//返回项目所有的产品文章 data.json
	getProjectProdDesc ({ state }, params) {
		return templateApi.getProjectProdDesc(params)
	},
	//项目ID查询项目权限的接口
	async selectSuitDetailByProjectId ({ state }, params) {

		let { data } = await templateApi.selectSuitDetailByProjectId({ projectId: params })
		return data
	},
	//查询 文章页 详情页 单页数量
	async getPageCount ({ state }, params) {
		let { data } = await templateApi.getPageCount(params)
		return data
	},
	//保存子域名
	saveOrUpdateSubDomain ({ state }, params) {
		return templateApi.saveOrUpdateSubDomain(params)
	},
}

export default actions
